// extracted by mini-css-extract-plugin
export default {"wrapper":"imnwVilwhufHANZE04CA"};